import React from "react";
import { useIntl } from "react-intl";
import { classNames } from "@ct-react/core";
import { Button } from "../common/minimals";
import { agencyTranslations, bookingTranslations } from "../../i18n/sharable-defs";
import "./ondemand-box.scss";

type OnDemandBoxProps = {
  onAction?: () => void;
}

const OndemandBox = ({ onAction = () => void 0 }: OnDemandBoxProps) => {

  const intl  = useIntl();
  const wrapperClasses = classNames("rla-book-ondemand");

  return (
    <div className={wrapperClasses}>
      <Button className="large bolder"
              type="button"
              onClick={() => onAction()}>{intl.formatMessage(agencyTranslations.contact)}</Button>
      <span className="textual-ondemand">
        {intl.formatMessage(bookingTranslations.onDemandHelper)}
      </span>
    </div>);

};

export default OndemandBox;
